document.getElementById('microsoft-btn').addEventListener('click', async () => {
    // Desktop app (Electron): the main process runs the Entra sign-in in the
    // system browser (window.proteaAuth bridge) and navigates this window into
    // the app on success. Browser: the classic redirect flow via the hub.
    if (!window.proteaAuth) {
        location.href = '/api/auth/oidc/login';
        return;
    }
    const btn = document.getElementById('microsoft-btn');
    const errorEl = document.getElementById('error-msg');
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Waiting for browser sign-in…';
    errorEl.style.display = 'none';
    const res = await window.proteaAuth.ssoLogin();
    if (!res.ok) {
        errorEl.textContent = res.error || 'Sign-in failed — please try again';
        errorEl.style.display = 'block';
        btn.disabled = false;
        btn.textContent = original;
    }
    // On success the main process navigates this window to the dashboard.
});

// Desktop app: offer "Work offline" so you can use direct connect without the
// hub (no internet → can't log in anyway). setOffline() persists + relaunches.
if (window.proteaMode) {
    const offlineBtn = document.getElementById('offline-btn');
    if (offlineBtn) {
        offlineBtn.style.display = '';
        offlineBtn.addEventListener('click', () => {
            offlineBtn.disabled = true;
            offlineBtn.textContent = 'Switching to offline…';
            window.proteaMode.setOffline();
        });
    }
}
